import React from "react";
import { Page, Text, View, Document } from "@react-pdf/renderer";
import { styles } from "../styles";

// Create Document Component
export const DistributionDoc = (props) => {
  return (
    <Document>
      <Page size="A4" wrapping={true} style={styles.page}>
        {props.title && (
          <Text style={styles.pageHeaderText}>Distribution Chain</Text>
        )}
        {props.notSM && (
          <View style={styles.section}>
            <Text style={styles.headerText}>SOLD TO</Text>
            {props.salesData &&
              props.salesData.map((sale) => (
                <Text style={styles.text}>{sale}</Text>
              ))}
          </View>
        )}
        <View style={styles.section}>
          {props.notSM && (
            <>
              <Text style={styles.headerText}>FINAL INFUSED PRODUCT</Text>
              <Text style={styles.text}>
                <Text style={styles.subHeaderText}>
                  Product Manufactured by:{" "}
                </Text>
                {props.mfr}
              </Text>
              {props.dstr && (
                <Text style={styles.text}>
                  <Text style={styles.subHeaderText}>
                    Product Distributed by:{" "}
                  </Text>
                  {props.dstr}
                </Text>
              )}
              <Text style={styles.text}>
                <Text style={styles.subHeaderText}>Licensed and Sold By: </Text>
                {props.licHldr}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.subHeaderText}>
                  Marijuana Establishment License #:{" "}
                </Text>
                {props.license}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.subHeaderText}>Batch ID: </Text>
                {props.batchId}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.subHeaderText}>Date of Manufacture: </Text>
                {new Date(props.mfrDate).toLocaleDateString("en-US")}
              </Text>
            </>
          )}
          <>
            {props.data.map((sourceMed) => (
              <View style={styles.subSection}>
                <View wrap={false}>
                  <Text style={styles.headerText}>SOURCE EXTRACT</Text>
                  <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>
                      License Holder Name:{" "}
                    </Text>
                    {sourceMed.licenseName}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>
                      Marijuana Establishment License #:{" "}
                    </Text>
                    {sourceMed.MEL}
                  </Text>
                  {/* <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>
                      Marijuana Establishment Address:{" "}
                    </Text>
                    {sourceMed.address[0]}
                  </Text> */}
                  <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>Manufactured by: </Text>
                    {sourceMed.mfrBy}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>Batch ID: </Text>
                    {sourceMed.sourceMedBatch}
                  </Text>
                  <Text style={styles.text}>
                    <Text style={styles.subHeaderText}>
                      Date of Manufacture:{" "}
                    </Text>
                    {new Date(sourceMed.mfrDate).toLocaleDateString("en-US")}
                  </Text>
                </View>
                {sourceMed.cultivators.map((cultivator) => (
                  <>
                    <View style={styles.subSection} wrap={false}>
                      <Text style={styles.headerText}>CULTIVATED MATERIAL</Text>
                      <Text style={styles.text}>
                        <Text style={styles.subHeaderText}>
                          License Holder Name:{" "}
                        </Text>
                        {cultivator.licenseName}
                      </Text>
                      <Text style={styles.text}>
                        <Text style={styles.subHeaderText}>
                          Marijuana Establishment License #:{" "}
                        </Text>
                        {cultivator.MEL}
                      </Text>
                      {/* <Text style={styles.text}>
                        <Text style={styles.subHeaderText}>
                          Marijuana Establishment Address:{" "}
                        </Text>
                        {cultivator.cultivatorAddress}
                      </Text> */}
                      <Text style={styles.text}>
                        <Text style={styles.subHeaderText}>Harvested By: </Text>
                        {cultivator.harvestedBy}
                      </Text>
                    </View>
                    <View style={styles.subSection} wrap={true}>
                      {cultivator.batches.map((batch) => (
                        <View>
                          <Text style={styles.text}>
                            <Text style={styles.subHeaderText}>Batch ID: </Text>
                            {batch.batchId}
                          </Text>
                          <View style={styles.subSection}>
                            <Text style={styles.text}>
                              <Text style={styles.subHeaderText}>
                                Harvest Date:{" "}
                              </Text>
                              {batch.harvestDate}
                            </Text>
                            {/* <Text style={styles.text}>
                              <Text style={styles.subHeaderText}>
                                Harvest Address:{" "}
                              </Text>
                              {batch.harvestAddress}
                            </Text> */}
                          </View>
                        </View>
                      ))}
                    </View>
                  </>
                ))}
              </View>
            ))}
          </>
        </View>
      </Page>
    </Document>
  );
};
